module.exports = __webpack_public_path__ + "static/content-below-product-image-d92976ecb404a610ed55bac893ae4e06.png";